import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { isEmpty } from 'lodash'
import { toast } from 'react-toastify'
import { centsToDollars } from '../../utils/formatters'

import BackChevron from '../BackChevron'
import CartDetails from '../CartDetails'
import ConfirmNotification from '../ConfirmNotification'

import styles from './TabOrderCartDetails.module.scss'

const TabOrderCartDetails = ({ history, order, hasCartItems, className }) => {
  const classNames = cn(styles.tabOrderCartDetails, className)
  const [toastMessage, setToastMessage] = useState({ show: false, id: null })

  if (isEmpty(order)) return( <div/> )

  const centsAsDollars = (cents) => centsToDollars(cents || 0)

  const onBack = () => history.push(`/tabs/${order.uuid}`)

  const toggleMessages = () => {
    toast.dismiss(toastMessage.id)
    setToastMessage({ show: false, id: null })
  }

  const checkCartBeforeConfirm = (onConfirm) => {
    const notification = (
      <ConfirmNotification
        className={className}
        label={'Warning'}
        message={
          'Items currently in cart will be removed once navigating away from the menu. Do you wish to continue?'
        }
        onCancel={toggleMessages}
        onConfirm={onConfirm}
        buttonOneText={'Cancel'}
        buttonTwoText={'Confirm Cart Abandonment'}
      />
    )

    if (hasCartItems) {
      const toastId = toast(notification, { autoClose: false, closeOnClick: false })
      setToastMessage({ show: true, id: toastId })
    } else {
      onConfirm()
    }
  }

  return (
    <div className={classNames}>
      <div className={styles.backButtonRow} onClick={() => checkCartBeforeConfirm(onBack)}>
        <BackChevron className={styles.backChevron} />
        <div className={styles.orderNumber}>
          {order.orderNumber}
        </div>
      </div>
      <CartDetails
        lineItemPrefix='tab'
        subtotal={centsAsDollars(order.amountInCents)}
        tax={centsAsDollars(order.tax)}
        total={centsAsDollars(order.amountInCents)}
      />
    </div>
  )
}

TabOrderCartDetails.defaultProps = {
  order: {},
}

TabOrderCartDetails.propTypes = {
  order: PropTypes.object,
}

export default withRouter(TabOrderCartDetails)
